// WorkshopAgenda.js
import React from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import Markdown from './Markdown.js';

// Single timeline entry
const TimelineItem = ({ time, title, description, isLast }) => {
  const itemStyle = { position: 'relative', marginBottom: isLast ? 0 : '2rem' };
  const circleStyle = {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '1rem',
    height: '1rem',
    borderRadius: '50%',
    backgroundColor: '#0d6efd',
  };
  const contentStyle = { marginLeft: '1.5rem' };

  return (
    <div style={itemStyle}>
      <div style={circleStyle} />
      <div style={contentStyle}>
        <strong>{time}</strong>
        <p className="mb-1"><strong>{title}</strong></p>
        <p className="text-muted mb-0">{description}</p>
      </div>
    </div>
  );
};


const WorkshopAgenda = ({
  preHeading,
  heading,       // can be a string or JSX
  description,
  cardTitle,
  timelineData,  // array of { time, title, description }
  spineStyle,    // your vertical line styling
  sectionBg = '#f8f9fa',
  sectionClass = 'py-5',
  cardPaddingLeft = '2.5rem',
}) => (
  <section className={sectionClass} style={{ backgroundColor: sectionBg }}>
    <Container>
      <Row className="align-items-center">
        {/* Left column */}
        <Col md={6} className="mb-4 mb-md-0">
          <small className="text-uppercase text-muted">
            {preHeading}
          </small>
          <h2 className="mt-2">
           <Markdown md={heading} />
          </h2>
          <p className="mt-3">{description}</p>
        </Col>

        {/* Right column */}
        <Col md={6}>
          <Card className="shadow-sm border-0">
            <Card.Header className="bg-white border-0 pb-0">
              <h5 className="mb-4">{cardTitle}</h5>
            </Card.Header>
            <Card.Body style={{ position: 'relative', paddingLeft: cardPaddingLeft }}>
              <div style={spineStyle} />
              {timelineData.map((item, idx) => (
                <TimelineItem
                  key={idx}
                  time={item.time}
                  title={item.title}
                  description={item.description}
                  isLast={idx === timelineData.length - 1}
                />
              ))}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  </section>
);

export default WorkshopAgenda;